if($(window).width() < 767 ){
  height = $(window).height();
  $('.ss-background-image-container').css({'line-height': height, 'height': height });
}

$(window).resize(function(){
  if($(window).width() < 767 ){
    height = $(window).height();
    $('.ss-background-image-container').css({'line-height': height, 'height': height });
  }
});

product_slider = new Swiper('.product-slider', {
  slidesPerView: 1,
  loop: true,
  loopedSlides: 4,
  allowTouchMove: false,
  preloadImages: false,
  autoHeight: true,
  lazy: {
    loadPrevNext: true,
  },
  breakpoints: {
    767: {
      loopedSlides: 1
    }
  }
});

navigation_slider = new Swiper('.navigation-slider', {
  slidesPerView: 7,
  centeredSlides: true,
  loop: true,
  allowTouchMove: false,
  loopedSlides: 4,
  breakpoints: {
    767: {
      slidesPerView: 3,
    },
    325: {
      slidesPerView: 3
    }
  },
  observer: true
});

shopping_slider = new Swiper('.shopping-slider', {
  navigation: {
    nextEl: '.ss-button-next',
    prevEl: '.ss-button-prev',
  },
  loop: true,
  loopedSlides: 4,
  simulateTouch: false,
  autoHeight: true,
  keyboard: {
    enabled: true,
    onlyInViewport: false,
  },
  preloadImages: false,
  lazy: {
    loadPrevNext: true
  },
  breakpoints: {
    767: {
      loopedSlides: 1
    }
  }
}); 

shopping_slider.controller.control = product_slider;

function update_sliders(){
  shopping_slider.loopDestroy();
  shopping_slider.loopCreate();
  shopping_slider.update();
  product_slider.loopDestroy();
  product_slider.loopCreate();
  product_slider.update();
};

function history_replacement(){
  // History replacement
  handle = $('.shopping-slider .swiper-slide-active .ss-product-image-block').first().data('product-handle');
  window.history.replaceState(null, '', '?slide=' + handle);
  //window.location.hash = 'slide=' + handle;
};

function sliders_work(){
  if ($(window).width() < 767){
    $('.ss-desktop-slide').css('display','none').removeClass('swiper-slide');
    $('.ps-desktop-slide').css('display','none').removeClass('swiper-slide');
    $('.ss-mobile-slide').css('display','block').addClass('swiper-slide');
    $('.ps-mobile-slide').css('display','block').addClass('swiper-slide');
    update_sliders();
    $('.ss-desktop-slide').removeClass('swiper-slide-active');
    $('.ps-desktop-slide').removeClass('swiper-slide-active');
    $('.swiper-slide-duplicate .swiper-lazy-loading').each(function(){
      src = $(this).data('src');
      $(this).attr('src', src);
    });
    previous_slide_index = $('.ss-mobile-slide.swiper-slide-active').data('slide-index');
    slide_index = $('.ss-mobile-slide.swiper-slide-active').data('slide-index');
    $("#dot-" + slide_index).addClass('active');
    shopping_slider.on('slideChangeTransitionEnd', function () {
      if ($(window).width() < 767){     
        slide_index = $('.ss-mobile-slide.swiper-slide-active').data('slide-index');
        $('.navigation-dot.active').removeClass('active');
        $("#dot-" + slide_index).addClass('active');
        if (previous_slide_index == 3 && slide_index == 1){
          navigation_slider.slideNext();
        }
        if (previous_slide_index == 1 && slide_index == 3){
          navigation_slider.slidePrev();
        }
        previous_slide_index = slide_index;

        history_replacement()
      }
    });    
  } else {
    $('.ss-mobile-slide').css('display','none').removeClass('swiper-slide');
    $('.ps-mobile-slide').css('display','none').removeClass('swiper-slide');
    $('.ss-desktop-slide').css('display','block').addClass('swiper-slide');
    $('.ps-desktop-slide').css('display','block').addClass('swiper-slide');
    update_sliders();
    $('.ss-mobile-slide').removeClass('swiper-slide-active');
    $('.ps-mobile-slide').removeClass('swiper-slide-active');
    $('.swiper-slide-duplicate .swiper-lazy-loading').each(function(){
      src = $(this).data('src');
      $(this).attr('src', src);
    });
    
    shopping_slider.on('slideNextTransitionStart', function () { 
      if ($(window).width() > 767){     
      	navigation_slider.slideNext();
      }
    });
    shopping_slider.on('slidePrevTransitionStart', function () { 	
      if ($(window).width() > 767){
      	navigation_slider.slidePrev();
      }
    });
    
    shopping_slider.on('slideChangeTransitionStart', function () { 
      history_replacement();
    });
    
  }
};

jQuery(function($) {
  if ($(window).width() > 767){
    $('.ps-desktop-slide.swiper-slide-active .lazy').Lazy({
      	onFinishedAll: function() {
          $('.ps-desktop-slide.swiper-slide-active .lazy-gif').Lazy({
            delay: 2000
          });
        }
    });
  } else {
    $('.ps-mobile-slide.swiper-slide-active .lazy').Lazy({
      	onFinishedAll: function() {
          $('.ps-mobile-slide.swiper-slide-active .lazy-gif').Lazy({
            delay: 2000
          });
        }
    });
  }
  
  product_slider.on('slideChangeTransitionEnd', function() {
    if ($(window).width() > 767){
      $('.ps-desktop-slide.swiper-slide-active .lazy').Lazy({
        onFinishedAll: function() {
          $('.ps-desktop-slide.swiper-slide-active .lazy-gif').Lazy({
            delay: 2000
          });
        }
      });
    } else {
      $('.ps-mobile-slide.swiper-slide-active .lazy').Lazy({
        onFinishedAll: function() {
          $('.ps-mobile-slide.swiper-slide-active .lazy-gif').Lazy({
          	delay: 2000
          });
        }
      });
    }
  });
});

$('.navigation-button-next').on('click', function(){
  $('.ss-button-next').click();
});
$('.navigation-button-prev').on('click', function(){
  $('.ss-button-prev').click();
});    
function slide_to_handle_from_url(){
  if(window.location.href.includes('?slide=')){
    handle = window.location.href.split('?slide=')[1];
  	if ($(window).width() < 767){
      image_block = $(".shopping-slider .ss-mobile-slide:not(.swiper-slide-duplicate) .ss-product-image-block[data-product-handle='"+ handle +"']").first();
      shopping_slide_index = image_block.parents('.ss-mobile-slide').data('swiper-slide-index');
      shopping_slider.slideToLoop(shopping_slide_index);
      
      dot_index = image_block.parents('.ss-mobile-slide').data('slide-index');
      $('.navigation-dot.active').removeClass('active');
      $("#dot-" + dot_index).addClass('active');
      navigation_slide_index = Math.floor(shopping_slide_index / 3);
      navigation_slider.slideToLoop(navigation_slide_index);
    }
    else{      
      image_block = $(".shopping-slider .ss-desktop-slide:not(.swiper-slide-duplicate) .ss-product-image-block[data-product-handle='"+ handle +"']").first();
      slide_index = image_block.parents('.ss-desktop-slide').data('swiper-slide-index');
      shopping_slider.slideToLoop(slide_index);
      navigation_slider.slideToLoop(slide_index);
    }
  }
};

sliders_work();
slide_to_handle_from_url()

$( window ).resize(function() {
  sliders_work();
  //slide_to_handle_from_url();
});

$('.ss-divider-link').click(function(e){
  e.preventDefault();
  element = $(this).attr('href');
  $('html, body').animate({
    scrollTop: $('#' + element).offset().top - $('.custom-header').height()
  }, 500);
});

$('.ps-thumbnail-slide').on('click',function(){
	$(this).parents('.ps-images-container').find($('.ps-thumbnail-slide')).removeClass('active');
  	$(this).addClass('active');
  	image_slide = $(this).data('image');
  	$(this).parents('.ps-images-container').find($('.ps-main-images-slide')).removeClass('active');
  	$(this).parents('.ps-images-container').find('#main-image-'+image_slide).addClass('active');
});

$('#navigation-dots').on('click', '.navigation-dot.active', function(){
  $('html, body').animate({
    scrollTop: $('.ps-mobile-slide.swiper-slide-active .ps-products-container').offset().top
  }, 500);
});

if ($(window).width() > 767){
  product_height = $('.ps-desktop-slide.swiper-slide-active').find('.ps-product-block:not(.expanded)').height();
  product_slider.on('slideChangeTransitionEnd', function () {
    if ($('.ps-desktop-slide.swiper-slide-active').find('.ps-product-block:not(.expanded)').length > 0){
    	product_height = $('.ps-desktop-slide.swiper-slide-active').find('.ps-product-block:not(.expanded)').height();
    } else {
      expanded_block_height = $('.ps-desktop-slide.swiper-slide-active').find('.pslider-expandable-menu').height();
      product_height = $('.ps-desktop-slide.swiper-slide-active').find('.ps-product-block').height() - expanded_block_height;
    }
  });
}

$('.em-button').on('click', function(){
  $(this).children('.em-down').toggleClass('up');
  if ($(window).width() < 767){
    $(this).next().slideToggle( "slow", function() {
      product_slider.updateAutoHeight(100);
    });  
  } else {
    $(this).toggleClass('expanded');
    $(this).parents('.ps-product-block').toggleClass('expanded');
    $('.em-button:not(.expanded)').css('margin-top', 0);
    $(this).parents('.ps-products-container').children('.ps-product-block').css('max-height', product_height);
    title_height = $(this).parents('.ps-product-block').find('.pslider-title').outerHeight(true);
    author_height = $(this).parents('.ps-product-block').find('.pslider-author').outerHeight(true);
    description_height = $(this).parents('.ps-product-block').find('.pslider-description').outerHeight(true);
    text_block_height = $(this).parents('.ps-product-block').find('.pslider-text-block').height();
    margin = text_block_height - title_height - author_height - description_height;
    $(this).css('margin-top', margin);

    $('.ps-product-block.expanded').css('max-height', 'none');
    $(this).next().toggle();
    product_slider.updateAutoHeight(300);
  }
});

window.onload = function () { product_slider.updateAutoHeight(300); }